import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid auto-cols-min grid-cols-4 place-items-center gap-x-5`}
`
export const SocialLink = styled.a.attrs((props) => ({ ...props, target: '_blank', rel: 'noreferrer' }))``
